import * as amplitude from '@amplitude/analytics-browser';
import { AnalyticsApp, AnalyticsPlatform } from '@focuslee/shared';
import { openTelegramLink } from '@tma.js/sdk';
import { AnalyticsEventType } from '../contexts/analyticsEvents';

const e2eExternalLink = process.env.REACT_APP_E2E_EXTERNAL_LINK ?? new URLSearchParams(window.location.search).get('e2eExternalLink');

export const openExternalLink = (link?: string | null): void => {
    const target = e2eExternalLink ?? link;
    if (!target) return;
    if (/healthlee/i.test(target)) {
        amplitude.track(AnalyticsEventType.CROSS_SELL_CLICKED, {
            target_app: AnalyticsApp.healthlee,
            source: 'external_link',
            app: AnalyticsApp.focuslee,
            platform: AnalyticsPlatform.telegramMiniApp,
        });
    }
    if (e2eExternalLink || !openTelegramLink.isAvailable()) {
        window.location.assign(target);
        return;
    }
    openTelegramLink(target);
};
